
import React from "react";
import "../../Styles/certified/softone.css";

export default function Softone() {
	return (
		<>
			<div className="softone-certified-details-section">
				<div className="softone-certified-details-title">
					OUTSTANDING WORKPLACES CERTIFIED COMPANIES
				</div>
				<div className="softone-certified-details-container">
					{/* Left: Badge and Company Info side by side */}
					<div className="softone-certified-details-left">
						<img
							src="/Certified_Ribbon/Jan2026Jan2027.png"
							alt="Outstanding Workplaces Certified"
							className="softone-certified-badge"
						/>
						<div className="softone-certified-company-names">
							<a href="https://softonehr.com" target="_blank" rel="noopener noreferrer">
								<img src="/assets/softone/softone.png" alt="Softone Logo" className="softone-certified-company-logo" />
							</a>
							<h1 className="softone-certified-full-name">
								Softone HR Solutions Private Limited
							</h1>
						</div>
					</div>
					{/* Right: Company Image */}
					<div className="softone-certified-details-right">
						<img
							src="/assets/softone/1000333137.jpg"
							alt="Softone Office"
							className="softone-certified-company-image"
						/>
					</div>
				</div>
				{/* Description section below */}
				<div className="softone-certified-description">
					<h2>
						Why Softone HR Solutions Private Limited is an Outstanding Workplaces
					</h2>
					<p>
						Softone HR Solutions Pvt Ltd is a Chennai-based human resources and staffing company specializing in delivering high-quality recruitment and workforce solutions for both IT and non-IT sectors. Founded in 2020, the company partners with organisations to streamline their talent acquisition efforts by providing tailored staffing services—including permanent and contract staffing—through a quality-focused, technology-enabled approach. With a commitment to client satisfaction and a strong track record of matching skilled professionals to the right roles, Softone HR Solutions helps businesses effectively plan, build, and run their critical hiring initiatives. With a strong focus on quality, integrity, and client partnership, the company supports organisations in building efficient and future-ready workforces through customised recruitment and staffing services.
					</p>
				</div>
				{/* Info Cards Section */}
				<div className="softone-certified-info-cards">
					<div className="softone-certified-info-card">
						<div className="softone-certified-info-title">COMPANY SIZE</div>
						<div className="softone-certified-info-value">17 Employees</div>
					</div>
					<div className="softone-certified-info-card">
						<div className="softone-certified-info-title">INDUSTRY</div>
						<div className="softone-certified-info-value">Staffing Services</div>
					</div>
					<div className="softone-certified-info-card">
						<div className="softone-certified-info-title">CONNECT</div>
						<div className="softone-certified-info-icons">
							<span className="softone-certified-icon-round">
								<a href="https://softonehr.com" target="_blank" rel="noopener noreferrer">
									<img src="/assets/website.png" alt="Website" />
								</a>
							</span>
							<span className="softone-certified-icon-round">
								<a href="https://www.linkedin.com/company/softone-hr" target="_blank" rel="noopener noreferrer">
									<img src="/assets/linkedin.png" alt="LinkedIn" />
								</a>
							</span>
							<span className="softone-certified-icon-round">
								<a href="https://x.com/HrSoftone?mx=2" target="_blank" rel="noopener noreferrer">
									<img src="/assets/x.png" alt="X" />
								</a>
							</span>
                            <span className="softone-certified-icon-round">
                                <a href="https://www.facebook.com/softoneHR/" target="_blank" rel="noopener noreferrer">
                                    <img src="/assets/facebook.png" alt="Facebook" />
                                </a>
                            </span>
                            <span className="softone-certified-icon-round">
                                <a href="https://www.instagram.com/softonehr?igsh=cGhraGg5MHRwcjlv" target="_blank" rel="noopener noreferrer">
                                    <img src="/assets/instagram.png" alt="Instagram" />
                                </a>
                            </span>
                            <span className="softone-certified-icon-round">
                                <a href="https://www.youtube.com/channel/UCgTxZ6E1t4cmyET10Du3SfQ" target="_blank" rel="noopener noreferrer">
                                    <img src="/assets/youtube.png" alt="YouTube" />
                                </a>
                            </span>
						</div>
					</div>
					<div className="softone-certified-info-card">
						<div className="softone-certified-info-title">LOCATION (HQ)</div>
						<div className="softone-certified-info-value">Chennai</div>
					</div>
				</div>
				{/* Recognitions Section */}
				<div className="softone-certified-recognition-section">
					<h2 className="softone-certified-recognition-title">
						Recognitions awarded by Outstanding Workplaces
					</h2>
					<div className="softone-certified-recognition-badge">
						<img
							src="/Certified_Ribbon/Jan2026Jan2027.png"
							alt="Outstanding Workplaces Certified"
							className="softone-certified-recognition-image"
						/>
					</div>
					<div className="softone-certified-recognition-label">
						Outstanding Workplaces - Platinum Certified
					</div>
				</div>
				{/* Life at Softone Section */}
				<div className="softone-certified-life-section">
					<h2 className="softone-certified-life-title">
						Life at Softone HR Solutions Private Limited
					</h2>
					<div className="softone-certified-life-gallery">
						<div className="softone-certified-life-col">
							<img src="/assets/softone/1000333137.jpg" alt="Office 1" className="softone-certified-life-img" />
							<img src="/assets/softone/1000333139.jpg" alt="Team 1" className="softone-certified-life-img" />
						</div>
						<div className="softone-certified-life-col softone-certified-life-center">
							<img src="/assets/softone/1000333136.jpg" alt="Main Office" className="softone-certified-life-img softone-certified-life-img-large" />
						</div>
						<div className="softone-certified-life-col">
							<img src="/assets/softone/1000333135.jpg" alt="Office 2" className="softone-certified-life-img" />
							<img src="/assets/softone/1000333173.jpg" alt="Team 2" className="softone-certified-life-img" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
